import { Suspense, useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { ExperimentTree } from '@/features/experiments/ui/ExperimentTree';

import { ExperimentContents } from '@/widgets/experiments/ExperimentContents';

import styles from './ExperimentsPage.module.css';

const ExperimentsPage = () => {
  const { projectId, experimentId } = useParams<{ projectId?: string; experimentId?: string }>();

  const content = useMemo(() => {
    return <ExperimentContents selectedProjectId={projectId} selectedExperimentId={experimentId} />;
  }, [projectId, experimentId]);

  return (
    <div className={styles.experimentsPage}>
      <div className={styles.treeWrapper}>
        <ExperimentTree selectedProjectId={projectId} selectedExperimentId={experimentId} />
      </div>
      <div className={styles.contentWrapper}>
        <Suspense fallback={<div className={styles.fallback} />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default ExperimentsPage;
